var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Container, FormGroup, Form, Card, CardBody } from 'reactstrap';
import { ApplicationContext } from '../../../../ApplicationContext';
import { FormErrorContext } from '../../../../FormErrorContext';
import CardTitleHeader from '../../../components/ui/Cards/CardTitleHeader';
import FormField from '../../../components/ui/FormField/FormField';
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
var AssetServiceEntryOverlay = /** @class */ (function (_super) {
    __extends(AssetServiceEntryOverlay, _super);
    /**
     *
     * @param props
     */
    function AssetServiceEntryOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        return _this;
    }
    /**
     *
     * @return {*}
     */
    AssetServiceEntryOverlay.prototype.render = function () {
        var _a = this.props;
        return React.createElement(Container, { className: 'asset-notice-overlay w-100' },
            React.createElement(FormErrorContext.Provider, { value: { errors: this.state.errors } },
                React.createElement(Form, { onChange: this.onInputChange, onSubmit: this.onSubmit },
                    React.createElement(Card, null,
                        React.createElement(CardTitleHeader, { title: "Label" }),
                        React.createElement(CardBody, null,
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-12" },
                                    React.createElement(FormGroup, null,
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col" },
                                                React.createElement("label", { className: "font-weight-bold", htmlFor: "type" },
                                                    React.createElement(FormattedMessage, { id: "assetnotice.labels.field.type", defaultMessage: "Type melding" })))),
                                        React.createElement(FormField, null,
                                            React.createElement("select", { className: "form-control", id: "type", name: "type", required: true },
                                                React.createElement("option", { value: "MAINTENANCE" }, "Onderhoud"),
                                                React.createElement("option", { value: "INSPECTION" }, "Keuring"))))),
                                React.createElement("div", { className: "col-12" },
                                    React.createElement(FormGroup, null,
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col" },
                                                React.createElement("label", { htmlFor: "name", className: "font-weight-bold" },
                                                    React.createElement(FormattedMessage, { id: "assetnotice.labels.field.trackingtype", defaultMessage: "Tracking type" })))),
                                        React.createElement(FormField, null,
                                            React.createElement("div", { className: "d-block w-100" },
                                                React.createElement("input", { className: "custom-control-input", name: "trackingType", type: "radio", value: "", id: "hours" }),
                                                React.createElement("label", { className: "custom-control-label", htmlFor: "hours" },
                                                    React.createElement(FormattedMessage, { id: "assetnotice.labels.field.hours", defaultMessage: "Operationele uren" }))),
                                            React.createElement("div", { className: "d-block w-100" },
                                                React.createElement("input", { className: "custom-control-input", name: "trackingType", type: "radio", value: "", id: "period" }),
                                                React.createElement("label", { className: "custom-control-label", htmlFor: "period" },
                                                    React.createElement(FormattedMessage, { id: "assetnotice.labels.field.period", defaultMessage: "Periodiek" }))))))))))));
    };
    /**
     *
     */
    AssetServiceEntryOverlay.prototype.onInputChange = function () {
    };
    /**
     *
     */
    AssetServiceEntryOverlay.prototype.onSubmit = function () {
    };
    AssetServiceEntryOverlay.defaultProps = {
        className: ''
    };
    return AssetServiceEntryOverlay;
}(React.Component));
AssetServiceEntryOverlay.contextType = ApplicationContext;
export default injectIntl(AssetServiceEntryOverlay);
